var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.31579H8.29737C8.39738 7.31575 8.4953 7.28722 8.57968 7.23354C8.66406 7.17986 8.7314 7.10325 8.77381 7.01268C8.81623 6.92211 8.83196 6.82133 8.81916 6.72215C8.80637 6.62296 8.76558 6.52947 8.70158 6.45263L6.78947 4.15789L8.70158 1.86316C8.76558 1.78631 8.80637 1.69283 8.81916 1.59364C8.83196 1.49445 8.81623 1.39368 8.77381 1.30311C8.7314 1.21254 8.66406 1.13593 8.57968 1.08225C8.4953 1.02857 8.39738 1.00004 8.29737 1H1V11",
    stroke: "#F05A23",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag2);
export default __webpack_public_path__ + "static/media/flag-2.3f4122ec6713c020a81956afb70b4188.svg";
export { ForwardRef as ReactComponent };